export default __webpack_public_path__ + "static/media/piece-of-cake.9afbffde.png";